<div class="wrapper" [ngClass]="{ animate: loading }">
	<div class="number" *ngIf="!loading">{{ number }}</div>
	<div class="title" *ngIf="!loading">{{ title }}</div>
</div>
